import errorHandler from "../../handlers/errorHandler";
// import successHandler from "../../handlers/successHandler";
import { shipperService } from "../../services/shippers.service";
import { publicShipperService } from "../../services/publicShippers.service";
import shipperType from "./publicShippersTypes";

/**
 * GetAllShippers
 *
 */
export const getAllPublicShippers = (page) => async (dispatch) => {
  try {
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: true,
    });
    const response = await publicShipperService.getAllPublicShippers(page);
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    dispatch({
      type: shipperType["GET_ALL_PUBLIC_SHIPPERS"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Filter Shipper
 * @param {object} payLoad {company_id :"7b3e58e0-b68c-498d-b8d5-82198ef6d481"}
 * @returns {void}
 * */
export const filterPublicShippers = (payLoad, page) => async (dispatch) => {
  try {
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: true,
    });
    const response = await publicShipperService.filterPublicShipper(
      payLoad,
      page
    );
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: false,
    });
    dispatch({
      type: shipperType["FILTER_PUBLIC_SHIPPERS"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

export const filterShippersNoPage = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: true,
    });
    const response = await shipperService.filterShipperNoPage({
      ...payLoad,
    });
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: false,
    });
    dispatch({
      type: shipperType["FILTER_SHIPPERS_NOPAGE"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: shipperType["FILTERING"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Search Shipper
 * @param {object} payLoad {search:"ogwugo"}
 * @returns {void}
 * */
export const searchShippers = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: shipperType["LOADING_SEARCH"],
      payLoad: true,
    });
    const response = await shipperService.searchShipper({
      ...payLoad,
    });

    dispatch({
      type: shipperType["LOADING_SEARCH"],
      payLoad: false,
    });
    dispatch({
      type: shipperType["SEARCH_SHIPPERS"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: shipperType["LOADING_SEARCH"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Show Shipper
 * @param {object} payLoad {properties:1}
 * */
export const showShipper = (payLoad) => async (dispatch) => {
  try {
    const response = await shipperService.showAShipper(payLoad);

    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    dispatch({
      type: shipperType["SHOW_SHIPPERS"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
/**
 * Show my Shipper
 * @param {object} payLoad {properties:1}
 * */
export const showMyShipper = () => async (dispatch) => {
  try {
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    const response = await shipperService.showMyShipper();

    dispatch({
      type: shipperType["SHOW_MY_SHIPPERS"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: shipperType["LOADING_PUBLIC_SHIPPERS"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

export const storeCurrentShipper = (payload) => async (dispatch) => {
  dispatch({
    type: shipperType["STORE_CURRENT_SHIPPER"],
    payLoad: payload,
  });
};
